/**
 * FMO module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// FMO pages
const FmoListPage = lazyWithRetry(() => import('@/features/fmo/pages/FmoListPage'));
const FmoDetailsPage = lazyWithRetry(() => import('@/features/fmo/pages/FmoDetailsPage'));
const PaymentManagementPage = lazyWithRetry(() => import('@/features/fmo/pages/PaymentManagementPage'));

export const fmoRoutes: RouteObject[] = [
      // --------------------------------
      // FMO Module
      // --------------------------------
      {
        path: ROUTES.fmo.list,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <FmoListPage />
          </PermissionRoute>
        ),
      },
      {
        // «Управление платежами» on the FMO list; a static path, so it wins over `/fmo/:id`
        path: ROUTES.fmo.payments,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <PaymentManagementPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.fmo.details,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <FmoDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.fmo.verification,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoVerify}>
            <FmoDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.fmo.documents,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <FmoDetailsPage />
          </PermissionRoute>
        ),
      },
];
